// @ts-nocheck TODO: fix types for the entire file

import styled from '@emotion/styled';
import { TextField as MuiTextField } from '@mui/material';
import hexToRGBA from 'theme/hexToRGBA';
import pxToEm from 'theme/pxToEm';

interface FieldProps {
  isRounded?: boolean;
  disableAutofillStyles?: boolean;
}

export const TextField = styled(MuiTextField, {
  shouldForwardProp: (prop) =>
    !['isRounded', 'disableAutofillStyles'].includes(String(prop)),
})<FieldProps>`
  max-height: ${pxToEm(48)};
  &.MuiInputLabel-root,
  & .MuiInputLabel-outlined,
  & .MuiInputLabel-filled {
    color: ${({ theme: { palette } }) => palette.grey[600]};
    &.Mui-focused {
      color: ${({ theme: { palette } }) => palette.primary.dark};
    }
    &.Mui-disabled {
      color: ${({ theme }) =>
        theme.hexToRGBA(theme.palette.common.black, 0.38)};
    }
    &.Mui-error {
      color: ${({ theme }) => theme.palette.error.main};
    }
  }

  .MuiInputLabel-standard,
  .MuiInput-root.MuiInput-underline {
    padding-left: ${pxToEm(3)};

    &:before {
      border-bottom: ${({ theme }) =>
        `1px solid ${theme.palette.secondary?.light}`};
    }
  }

  & .MuiInputLabel-outlined,
  & .MuiInputLabel-filled {
    transform: none;
    position: relative;
    margin-bottom: ${pxToEm(8)};
    font-size: ${pxToEm(12)};
    line-height: 1;
  }
  & .MuiInputBase-root {
    border-radius: ${(props) => (props.isRounded ? '40px' : '6px')};
    & .MuiInputBase-input {
      background-color: initial;
    }
    &:not(.MuiInputBase-sizeSmall):not(.MuiInput-underline) {
      .MuiOutlinedInput-notchedOutline,
      .MuiInput-underline,
      .MuiInputBase-input,
      .MuiInputBase-multiline {
        padding-top: 0;
        padding-bottom: 0;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        ${({ disableAutofillStyles, theme }) =>
          !disableAutofillStyles &&
          `
            &:focus {
              box-shadow: none !important;
            }
            &:-webkit-autofill,
            &:-webkit-autofill:hover,
            &:-webkit-autofill:focus,
            &:-webkit-autofill:active {
              -webkit-box-shadow: 0 0 0 30px ${theme.palette.common.white} inset !important;
            }
        `}
      }
    }
    &.Mui-error {
      & .MuiInputLabel-outlined,
      & .MuiInputLabel-filled {
        background-color: ${({ theme: { palette } }) =>
          hexToRGBA(palette.error.main, 0.15)};
      }
    }
  }
  & .MuiOutlinedInput-root {
    background: ${({ theme: { palette } }) => palette.common.white};
    border-radius: ${(props) => (props.isRounded ? '40px' : '6px')};
  }
  & .MuiOutlinedInput-notchedOutline {
    top: 0;
    border-color: ${({ theme: { palette } }) => palette.grey[300]};
    & legend {
      display: none;
    }
  }
  & .Mui-focused {
    & .MuiOutlinedInput-notchedOutline {
      border-width: ${pxToEm(1)} !important;
      border-color: ${({ theme: { palette } }) =>
        palette.primary.dark} !important;
    }
  }

  & .Mui-error:not(.Mui-focused) {
    .MuiInputBase-input {
      color: ${({ theme: { palette } }) => palette.error.main};
    }
    *::-webkit-input-placeholder {
      color: ${({ theme: { palette } }) => palette.error.main};
    }
    *::-moz-placeholder {
      color: ${({ theme: { palette } }) => palette.error.main};
    }
    *::placeholder {
      color: ${({ theme: { palette } }) => palette.error.main};
    }
  }

  & .MuiFilledInput-root {
    background-color: ${({ theme: { palette } }) => palette.grey[200]};
  }
  & .MuiFilledInput-root,
  & .MuiInput-underline {
    &.Mui-focused {
      &:after {
        border-color: ${({ theme: { palette } }) =>
          palette.primary.dark} !important;
      }
    }
  }
  & .MuiFilledInput-root {
    &:before {
      display: none;
    }
  }
`;
